<div
  class="mkt-banner"
  data-cy="messageToolkitBanner"
  [ngStyle]="getBorderColor()"
>
  <div
    [ngClass]="getClasses()"
    class="idp__slimbanner--container row no-gutters"
    [ngStyle]="getBgColor()"
  >
    <div
      [ngClass]="getImageWrapperClasses()"
      class="idp__slimBanner--desktop banner-d-md-block text-align-center"
    >
      <div [ngClass]="getIconClasses()">
        <img
          [src]="config.mktBannerIconPath"
          alt="desktop alternative text"
          class="idp-image img-fluid"
        />
      </div>
    </div>
    <div [ngClass]="getBannerContentClasses()">
      <div class="banner-row margin-0">
        <div class="banner-col-12 padding-0">
          <div [ngClass]="config.alertsubheadingdate ? 'heding-wrapper' : ''">
            <h3 [ngClass]="getBannerLabelClasses()">
              {{ config.mktBannerLabel }}
            </h3>
            <div class="idp-date-section">
              {{ config.alertsubheadingdate }}
            </div>
          </div>
          <div
            [innerHTML]="config.mktBannerMessage"
            [ngClass]="getBannerMessageClasses()"
            [ngStyle]="getDescriptionColor()"
          ></div>
        </div>
      </div>
    </div>
  </div>
</div>
